import React, { useState, useRef, useEffect } from "react";
import { HashRouter as Router, Routes, Route, useSearchParams } from "react-router-dom";
import { MDBContainer } from "mdb-react-ui-kit";
import Header from "./components/Header";
import HeaderSearch from "./components/Header-Search";
import FilterSidebar from "./components/FilterSideBar/FilterSidebar";
import CommitteeList from "./components/CommitteeList";
import CommitteeDetails from "./components/CommitteeDetails/CommitteeDetails";
import AppBuildVersion from "./components/AppBuildVersion/AppBuildVersion";
import axios from "axios";
import ExportModal from "./components/Modals/ExportModal";
import VoteHistory from "./components/Modals/VoteHistory";
import {CookiesProvider} from "react-cookie";
import {useSelectedFiltersOrReportingCookie} from "./utils/useSelectedFiltersOrReportingCookie";

function AppContent() {
  const [searchTerm, setSearchTerm] = useState("");
  const [modeOpen, setModeOpen] = useState(false);
  // const [committeeType, setCommitteeType] = useState([]);
  const [filteredCommittees, setFilteredCommittees] = useState([]);
  const [relevantBills, setRelevantBills] = useState([]);
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => {
    setModeOpen(false);
    setBasicModal((prev) => !prev);
  };
  const [dateRange, setDateRange] = useState(null);
  const [sessionsData, setSessionsData] = useState({
    sessions: [],
    legislatures: [],
    activeSession: null,
    activeLegislature: null,
    filterSession: null,
    filterLegislature: null,
  });
  const [selectedLegislators, setSelectedLegislators] = useState({ legs: [], roles: [] });
  const [selectedChambers, setSelectedChambers] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [selectedBillTypes, setSelectedBillTypes] = useState([]);
  const [selectedBillStatus, setSelectedBillStatus] = useState(true);
  // for sidebar
  const sidenavContent = useRef(null);
  const [loadingExtraData, setLoadingExtraData] = useState(true);
  const [committees, setCommittees] = useState([]);
  const [selectedCommittees , setSelectedCommittees] = useState([]);
  const [selectedCommitteeTypes, setSelectedCommitteeTypes] = useState("RESET");
  const legislatureOrdinal = sessionsData?.filterLegislature?.ordinals || null;
  const [searchParams, setSearchParams] = useSearchParams();
  const [cookiesLoaded, setCookiesLoaded] = useState(false);
  const [dataFetched, setDataFetched] = useState(false)
  const billId = searchParams.get('billId');
  const {selectedFiltersOrReporting, updateSelectedFiltersOrReporting} = useSelectedFiltersOrReportingCookie();

  useEffect(() => {
    if (!cookiesLoaded && committees.length > 0) {
      if (Object.keys(selectedFiltersOrReporting).length === 0) {
        updateSelectedFiltersOrReporting({});
      } else {
        if(selectedFiltersOrReporting.filterSession &&
            selectedFiltersOrReporting.filterLegislature)
          setSessionsData({
            ...sessionsData,
            filterSession: selectedFiltersOrReporting.filterSession,
            filterLegislature: selectedFiltersOrReporting.filterLegislature,
          });

        if(selectedFiltersOrReporting.selectedChambers)
          setSelectedChambers(selectedFiltersOrReporting.selectedChambers);
        if(selectedFiltersOrReporting.selectedCommitteeTypes)
          setSelectedCommitteeTypes(selectedFiltersOrReporting.selectedCommitteeTypes);
        // if(selectedFiltersOrReporting.selectedCommittees)
        //   setSelectedCommittees(selectedFiltersOrReporting.selectedCommittees);
      }
      setCookiesLoaded(true)
    }

    const fetchData = async () => {
      try {
        // Fetch sessions
        const sessionsResponse = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/sessions`
        );
        const sessionsData = sessionsResponse.data;

        // Fetch legislatures
        const legislaturesResponse = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislatures`
        );
        const legislaturesData = legislaturesResponse.data;

        // Fetch activeSession and activeLegislature
        const activeSessionResponse = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/activeSessions/getActiveSession`
        );
        const sessionId = activeSessionResponse.data.sessionId;
        const sessionObject = sessionsData.find((item) => item.id === sessionId);

        if (sessionObject) {
          const legislatureId = sessionObject.legislature.id;
          const legislatureObject = legislaturesData.find((item) => item.id === legislatureId);

          setSessionsData({
            sessions: sessionsData,
            legislatures: legislaturesData,
            activeSession: sessionObject,
            activeLegislature: legislatureObject,
            filterSession: sessionObject,
            filterLegislature: legislatureObject,
          });
        }

        setDataFetched(true)
      } catch (error) {
        console.error("Error fetching sessionData:", error);
      }
    };

    if (!dataFetched)
      fetchData();
  }, [committees]);

  return (
    <>
      {sessionsData.activeLegislature ? (
        <>
          <Header />
          <MDBContainer fluid ref={sidenavContent}>
            <Routes>
              <Route
                path="/"
                element={
                  <MDBContainer fluid>
                    <HeaderSearch
                      searchTerm={searchTerm}
                      onSearchChange={setSearchTerm}
                      setModeOpen={setModeOpen}
                      modeOpen={modeOpen}
                      filterSession={sessionsData.filterSession}
                      filterLegislature={sessionsData.filterLegislature}
                      filteredCommittees={filteredCommittees}
                      selectedCommitteeTypes={selectedCommitteeTypes}
                      setSelectedCommitteeTypes={setSelectedCommitteeTypes}
                      relevantBills={relevantBills}
                      selectedLegislators={selectedLegislators}
                      selectedChambers={selectedChambers}
                      selectedBills={selectedBills}
                      selectedBillTypes={selectedBillTypes}
                      selectedBillStatus={selectedBillStatus}
                      dateRange={dateRange}
                      loadingExtraData={loadingExtraData}
                    />
                    {billId && (
                      <VoteHistory
                        basicModal={!!billId}
                        setBasicModal={() => {
                          const newParams = new URLSearchParams(searchParams);
                          newParams.delete('billId');
                          setSearchParams(newParams);
                        }}
                        billId={billId}

                      />
                    )}
                    <FilterSidebar
                      setFilterSession={(value) => {
                          updateSelectedFiltersOrReporting({filterSession: value})
                          setSessionsData((prev) => ({ ...prev, filterSession: value }))
                        }
                      }
                      setFilterLegislature={(value) => {
                          updateSelectedFiltersOrReporting({filterLegislature: value})
                          setSessionsData((prev) => ({ ...prev, filterLegislature: value }))
                        }
                      }
                      setModeOpen={setModeOpen}
                      modeOpen={modeOpen}
                      sidenavContent={sidenavContent}
                      // committeeType={committeeType}
                      // setCommitteeType={setCommitteeType}
                      sessions={sessionsData.sessions}
                      legislatures={sessionsData.legislatures}
                      activeLegislature={sessionsData.activeLegislature}
                      activeSession={sessionsData.activeSession}
                      filterSession={sessionsData.filterSession}
                      filterLegislature={sessionsData.filterLegislature}
                      setDateRange={setDateRange}
                      selectedLegislators={selectedLegislators}
                      setSelectedLegislators={setSelectedLegislators}
                      selectedChambers={selectedChambers}
                      setSelectedChambers={setSelectedChambers}
                      selectedBills={selectedBills}
                      setSelectedBills={setSelectedBills}
                      selectedBillTypes={selectedBillTypes}
                      setSelectedBillTypes={setSelectedBillTypes}
                      selectedBillStatus={selectedBillStatus}
                      setSelectedBillStatus={setSelectedBillStatus}
                      committees={committees}
                      filteredCommittees={filteredCommittees}
                      setFilteredCommittees={setFilteredCommittees}
                      relevantBills={relevantBills}
                      toggleOpen={toggleOpen}
                      loadingExtraData={loadingExtraData}
                      selectedCommittees={selectedCommittees}
                      setSelectedCommittees={setSelectedCommittees}
                      selectedCommitteeTypes={selectedCommitteeTypes}
                      setSelectedCommitteeTypes={setSelectedCommitteeTypes}
                      setLoadingExtraData={setLoadingExtraData}
                      updateSelectedFiltersOrReporting={updateSelectedFiltersOrReporting}
                    />
                    <CommitteeList
                      searchTerm={searchTerm}
                      filterSession={sessionsData.filterSession}
                      filterLegislature={sessionsData.filterLegislature}
                      // committeeType={committeeType}
                      setCommittees={setCommittees}
                      committees={committees}
                      cookiesLoaded={cookiesLoaded}
                      setFilteredCommittees={setFilteredCommittees}
                      filteredCommittees={filteredCommittees}
                      setRelevantBills={setRelevantBills}
                      relevantBills={relevantBills}
                      dateRange={dateRange}
                      selectedLegislators={selectedLegislators}
                      selectedChambers={selectedChambers}
                      selectedBills={selectedBills}
                      selectedBillTypes={selectedBillTypes}
                      selectedBillStatus={selectedBillStatus}
                      setLoadingExtraData={setLoadingExtraData}
                      selectedCommittees={selectedCommittees}
                      selectedCommitteeTypes={selectedCommitteeTypes}
                    />
                    <ExportModal
                      toggleOpen={toggleOpen}
                      basicModal={basicModal}
                      setBasicModal={setBasicModal}
                      filteredCommittees={filteredCommittees}
                      selectedCommitteeTypes={selectedCommitteeTypes}
                      selectedLegislators={selectedLegislators}
                      selectedChambers={selectedChambers}
                      selectedBills={selectedBills}
                      selectedBillTypes={selectedBillTypes}
                      selectedBillStatus={selectedBillStatus}
                      dateRange={dateRange}
                    />
                    <AppBuildVersion />
                  </MDBContainer>
                }
              />
              <Route
                path="/standingCommittees/:id"
                element={<CommitteeDetails type="standing" legislatureOrdinal={legislatureOrdinal} />}
              />
              <Route
                path="/nonStandingCommittees/:id"
                element={<CommitteeDetails type="nonStanding" legislatureOrdinal={legislatureOrdinal} />}
              />
            </Routes>
          </MDBContainer>
        </>
      ) : (
        <div>Loading...</div>
      )}
    </>
  );
}

function App() {
  return (
    <CookiesProvider>
      <Router>
        <AppContent />
      </Router>
    </CookiesProvider>
  );
}

export default App;